export default class Validation {
    constructor(messageNumber = 0, value = false) {
        this.messageNumber = messageNumber;
        this.value = value;
    }
}
